import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import CumPerfRow from './CumPerfRow';
import { setActivePane, paneOpts } from '../../../actions';
import './PerformanceTable.css';
import i18n from '../../../i18n';

class CumPerfTable extends Component {
  viewStdPerf() {
    this.props.setActivePane(paneOpts.details);
  }

  getLatestStdPerformance(fund) {
    if (!fund?.stdPerformanceDaily || fund.stdPerformanceDaily.length === 0) {
      return null;
    }
    return fund.stdPerformanceDaily[fund.stdPerformanceDaily.length - 1];
  }

  getHeaderStdPerformance() {
    const { data } = this.props;
    const fundWithStdPerformance = data.find(
      (fund) => this.getLatestStdPerformance(fund) !== null
    );
    return fundWithStdPerformance
      ? this.getLatestStdPerformance(fundWithStdPerformance)
      : null;
  }

  hasAnyCumulativePerformanceValue() {
    const { data, wtRegion } = this.props;
    const baseFields = ['yrs1NAV', 'yrs3NAV', 'yrs5NAV', 'yrs10NAV', 'commonPeriodNAV'];
    const fieldsToCheck =
      wtRegion === 'US'
        ? ['mtdNAV', 'mos3NAV', 'ytdNAV', ...baseFields]
        : baseFields;

    return data.some((fund) => {
      const stdPerformanceDaily = this.getLatestStdPerformance(fund);
      if (!stdPerformanceDaily) {
        return false;
      }

      const fundFields =
        fund.type === 'BMK' ? fieldsToCheck : [...fieldsToCheck, 'inceptionNAV'];

      return fundFields.some((field) => {
        const value = stdPerformanceDaily[field];
        return value !== null && value !== undefined && value !== '';
      });
    });
  }

  // create the rows
  renderRows() {
    const { data, wtRegion } = this.props;
    const stdPerformanceDaily = this.getHeaderStdPerformance();

    if (!stdPerformanceDaily) {
      return null;
    }

    return data.map((fund) => {
      return (
        <CumPerfRow key={fund.externalID} fund={fund} wtRegion={wtRegion} />
      );
    });
  }

  // create the header
  renderHeader() {
    const { wtRegion } = this.props;
    const stdPerformanceDaily = this.getHeaderStdPerformance();

    if (!stdPerformanceDaily) {
      return null;
    }

    const asOfDate = new Date(stdPerformanceDaily.asOfDate).toLocaleDateString();
    const commonStartDate = new Date(
      stdPerformanceDaily.commonPeriodNAVStart
    ).toLocaleDateString();
    const commonEndDate = new Date(
      stdPerformanceDaily.commonPeriodNAVEnd
    ).toLocaleDateString();
    return (
      <thead>
        <tr>
          <th colSpan="3" className="textLeft">
            CUMULATIVE PERFORMANCE {i18n.t('as of')} {asOfDate}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th colSpan="3" className="borderleft borderbottom textCenter">
                {i18n.t('Cumulative Returns')}
              </th>
            </Fragment>
          )}
          <th colSpan="6" className="borderleft borderbottom textCenter">
            {i18n.t('Average Annual Total Returns')}
          </th>
        </tr>
        <tr>
          <th scope="col" className="textLeft">
            {i18n.t('Ticker')}
          </th>
          <th scope="col" className="textLeft">
            {i18n.t('Fund')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('Inception')}
            <br /> {i18n.t('Date')}
          </th>
          {wtRegion === 'US' && (
            <Fragment>
              <th scope="col" className="borderleft textCenter">
                {i18n.t('1-Month')}
              </th>
              <th scope="col" className="textCenter">
                {i18n.t('3-Month')}
              </th>
              <th scope="col" className="textCenter">
                {i18n.t('YTD')}
              </th>
            </Fragment>
          )}
          <th scope="col" className="borderleft textCenter">
            {i18n.t('1-Year')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('3-Year')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('5-Year')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('10-Year')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('Since')} <br />
            {i18n.t('Inception')}
          </th>
          <th scope="col" className="textCenter">
            {i18n.t('Common Period')}
            <br /> {commonStartDate} - {commonEndDate}{' '}
          </th>
        </tr>
      </thead>
    );
  }

  render() {
    if (!this.hasAnyCumulativePerformanceValue()) {
      return null;
    }

    return (
      <div>
        {/* <div className={s.heading} style={{lineHeight:'14px', marginBottom:'13px'}}>{i18n.t('Performance')}</div> */}
        <div className="table-responsive">
          <table className="table tableFC">
            {this.renderHeader()}
            <tbody>{this.renderRows()}</tbody>
          </table>
        </div>
        <div style={{ marginTop: 15, marginBottom: 65 }}>
          <a
            className="tickerLink"
            href="/standardized-performance"
            onClick={(e) => {
              e.preventDefault();
              this.viewStdPerf();
            }}
          >
            View quarterly standardized performance
          </a>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    wtRegion: state.params.wtRegion,
  };
}

export default connect(mapStateToProps, {
  setActivePane,
})(CumPerfTable);
